/* 中文简体 */
export default {
  local: {
    reacquire_password: "s后重新获取",

    account_login: "账号登录",
    mobile_number_login: "手机号登录",
    authentication_code_login: "验证码登录",
    account_name_email: "账号名称/邮箱",
    forgot_password: "忘记密码？",
    please_enter_the_account_number: "请输入账号",
    please_enter_the_password: "请输入密码",
    account_not_registered: "账号或密码错误",
    incorrect_password: "账号或密码错误",
    not_joined_the_class: "您未加入班级或加入的班级还未发布",
    password_lock_time: "密码错误次数过多，请10分钟后重试",
    password_lock: "当前账号已锁定，请稍后再试",
    phone_number: "手机号码",
    please_enter_your_mobile_number: "请输入手机号",
    mobile_number_format_error: "手机号码格式错误",
    mobile_number_is_not_registered: "手机号或密码错误",
    verification_code: "验证码",
    get_verification_code: "获取验证码",
    please_enter_the_verification_code: "请输入验证码",
    code_failure_or_error: "验证码已失效或错误",
    code_too_many_times: "验证码获取次数已超限，请24小时后重试",
    go_back: "返回",
    reset_your_password: "重置密码",
    new_password: "新密码",
    save_changes: "确认",
    reset_the_password_by_using_the_email_address: "使用邮箱重置",
    please_enter_the_password_address: "请设置密码",
    your_password_has_been_reset: "密码重置成功",
    password_rule: "6-18位字母数字及符号组合",
    emai: "邮箱",
    reset_the_password_by_using_the_mobile_number: "使用手机重置",
    please_enter_the_email_address: "请输入邮箱",
    unregistered_mailbox: "邮箱未注册",

    student: "学员",
    teacher: "教师",
    assistant: "助教",
    sign_in: "进入",
    identity_to_sign_in: "请选择登录身份",
    change_password: "修改密码",
    switch_identity: "切换身份",
    sign_out: "退出登录",
    class_on_phones: "手机上课",
    mobile_terminal_by_scanning: "手机扫描二维码或打开链接后可访问移动端",
    copy_link: "复制链接",
    shut_off: "关闭",
    account: "登录账号",
    old_password: "旧密码",
    re_enter_password: "再次输入",
    please_enter_the_old_password: "请输入旧密码",
    please_enter_the_new_password: "请输入新密码",
    please_re_enter_the_new_password: "请再次输入新密码",
    password_modified_successfully: "密码修改成功",
    old_password_error: "旧密码错误",

    user_name: "用户名",
    password: "密码",
    login: "登录",
    the_user_name_or_password_is_incorrect: "用户名或密码不正确",
    note: "提示",
    log_out: "退出",
    certificate_application: "申请证书",
    more: "展开",
    close: "收起",
    learn_courses: "学课程",
    class_schedule: "课程表",
    data_download: "资料下载",
    selective_courses: "拓展课程",
    receive_notices: "收通知",
    to_do_list: "待办事项",
    important_notices: "重要通知",
    write_summary: "写总结",
    project_comment: "评价项目",
    feedback: "反馈意见",
    my_summary: "我的总结",
    evaluate_service_quality: "评价服务质量",
    completed: "已完成",
    unavailable: "未开放",
    uncompleted: "未完成",
    coming_soon: "敬请期待",
    application_successful: "证书申请成功！",
    the_certificate_will_be_sent_to_your_mail:
      "审核通过后证书将在结业当天发送至您的邮箱，如有疑问请与班主任联系。",
    ok: "确定",
    please_complete_your_to_do_list: "请先完成所有待办事项后再申请证书！",
    to_complete: "去完成",
    would_you_like_to_check_your_reports: "申请证书前是否需要复核您的相关报告",
    no_modification_upon_submission: "提交后不可修改！",
    go_and_check: "去复核",
    submit: "确认申请",
    application_submitted: "证书已申请",
    my_class: "我的班级",
    course_calendar: "课程日历",
    back_to_today: "回今天",
    today: "今",
    course_replay: "课程回放",
    no_courses: "暂无课程",
    monday: "星期一",
    tuesday: "星期二",
    wednesday: "星期三",
    thursday: "星期四",
    friday: "星期五",
    saturday: "星期六",
    sunday: "星期日",
    instructor: "授课教师",
    host_key: "主持人密钥",
    comment: "评价",
    replay: "回看",
    join: "上课",
    class_begins_at: "上课时间",
    lasting_for: "时长",
    all: "全部",
    video: "视频",
    image: "图片",
    no_data: "暂无资料",
    china_today_serial_courses: "今日中国系列课程",
    language: "语言",
    features: "专题",
    finance: "金融中国",
    trade: "贸易中国",
    commerce: "商业中国",
    planning: "中国城规",
    infrastructure: "中国基建",
    development_cooperation: "中国国际发展合作",
    important_notices_title: "重要通知",
    all_notes: "全部通知",
    course: "课程通知",
    event: "活动通知",
    class: "班级通知",
    task: "任务通知",
    no_notes: "暂无通知",
    content: "通知详情",
    turn_to_page: "跳至“XXX”页",
    please_complete_the_report: "请完成报告“XXX”",
    please_complete_the_course_comment: "请完成课程“XXX”的课程评价",
    fill_in: "填写",
    no_matter: "暂无事项",
    list: "目录",
    original: "原画",
    speed: "倍数",
    scored: "XXX分",
    fill_in_at_least_XXX_characters: "至少填写“XXX”个字符",
    words_already_entered: "已输入XXX个字",
    submission_successful: "提交成功",
    up_to_10000_words: "最多输入1万字！",
    up_to_20000_words: "最多输入2万字！",
    up_to_50000_words: "最多输入5万字！",
    course_comment: "课程评价",
    to_submit: "提交",
    to_close: "关闭",
    instructions: "填写说明",
    evaluation_type: "评分类型",
    very_good: "很好",
    good: "好",
    bad: "不好",
    total_points: "总分",
    trainers_level: "授课教师水平",
    teaching_material_quality: "素材质量",
    translation_level: "翻译水平",
    interactive_communication_situation: "互动交流情况",
    multimedia_teaching_quality: "多媒体方式教学质量",
    course_degree_of_difficulty: "课程难易程度",
    correlation_between_course_and_the_program_theme:
      "课程内容与项目主题相关度",
    comment_table_score_hint:
      "备注：很好计2分，好计1分，不好计0分。每门课程满分为14分。",
    participants_feedback_form: "参训学员反馈意见表",
    participants_feedback_form_state:
      "衷心祝贺您圆满完成研修任务，请对本次研修班做出反馈意见。",
    participants_feedback_form_instructions:
      "学员填写反馈意见表主要反馈的是对整体研修项目的意见和建议。<br/>" +
      "除了关于对本期项目的意见反馈外，我们还想了解您对未来项目的需求和建议，具体包括：<br/>" +
      "1.您希望我们开设哪些课程主题？<br/>" +
      "2.您希望参访哪些中国城市？<br/>" +
      "3.您希望参访哪些类型的中国企业？<br/>" +
      "4.您是否有在中国或上海进行经贸、教育或其他合作的计划？<br/>" +
      "5.您是否有具体的商贸合作需求？",
    final_report: "参训学员总结报告",
    final_report_state:
      "衷心祝贺您圆满完成研修任务，请撰写本次研修班的总结报告。",
    final_report_instructions:
      "学员报告撰写内容，可包括以下四方面：<br/>" +
      "一是介绍学员基本背景及参训缘由。<br/>" +
      "二是对比总结，就学员所在国家和中国在有关专题领域的差异点进行对比，所涉及的方向不做具体限定。<br/>" +
      "三是分享研修亮点和研修收获。<br/>" +
      "四是研修结束后的期望。<br/>" +
      "注：以上内容仅供参考。",
    trainee_evaluation_form_of_foreign_assistance_training_program:
      "对外援助培训项目学员评估表",
    trainee_evaluation_form_of_foreign_assistance_training_program_state:
      "感谢您来参加本研修班/培训班项目。为使我们不断改进工作，请您对本次研修班/培训班作出客观评价，并就以下问题发表您的意见。感谢您的合作。",
    trainee_evaluation_form_of_foreign_assistance_training_program_instructions:
      "项目评估表是对此期研修项目的综合评价，希望评价能够如实反映基地开展项目的具体情况。评估表的评分意见对基地未来工作的改进和目前基地工作的肯定有着非常重要的意义。每个评分项<span>5</span>分为最高分，评价表总分为<span>100</span>分。",
      foreign_aid_training_service_quality_survey:
      "上海商学院援外培训服务质量调查表",
    foreign_aid_training_service_quality_survey_state:
      "非常感谢您参加本次研修班。为提高援外培训整体质量，我们恳请您对我单位各环节服务工作提出客观的评价。您宝贵的建议和意见将是我们今后工作的努力方向。",
    foreign_aid_training_service_quality_survey_instructions:
      "您只需在相应的评价项中打“√”。分值越高，表示您对该项服务越满意，5分为非常满意、4分为满意、3分为一般、2分为不满意，1分为非常不满意。如调查评价项中无法表达您的建议和意见，您可在相应的备注中写出您的想法。",
    points: "分",
    training: "培训评价",
    course_arrangement: "课程内容安排",
    suitability_of_course_quantity: "课堂授课数量适宜度",
    quality_of_teaching_materials_or_handouts: "教材或讲义质量",
    correlation_between_study_tours_and_the_program_theme:
      "参观考察与项目主题的联系",
    arrangement_for_study_tours_or_internships: "参观考察或实习活动安排",
    classrooms_and_teaching_equipments: "教室和教学设备",
    management: "管理评价",
    accommodation: "住宿条件（非单人单间为0）",
    airport_transfer_and_catering_services_arrangement: "接送机与伙食安排",
    opening_and_closing_ceremonies_arrangement: "开班、结业典礼安排",
    cultural_experience_and_extracurricular_activities_arrangement:
      "文化体验与课余活动安排",
    attitude_of_the_Chinese_staff: "中方工作人员的态度",
    organizational_skills_of_the_Chinese_staff: "中方工作人员的组织能力",
    english_communication_skills_of_the_Chinese_staff:
      "中方工作人员的外语沟通能力",
    synthesis: "综合评价",
    program_duration: "项目时间长短",
    help_of_the_program_on_your_future_work: "本项目对您今后工作的帮助",
    role_of_the_program_in_promoting_cooperation_between_China_and_your_country_in_the_relevant_fields:
      "本项目对中国与贵国在相关领域合作的促进作用",
    your_overall_evaluation_of_the_program: "您对项目的总体评价",
    your_suggestion_and_comment: "您的建议和留言",
    your_impression_of_China: "您对中国的印象",
    report: "填写报告",
    error_request: "请求失败",
    download_live_streaming_tool: "下载直播工具",
    windows_7_and_above: "Windows 7 及以上",
    no_replay: "暂无回放",
    look_over: "查看",
    mon: "一",
    tue: "二",
    wed: "三",
    thu: "四",
    fri: "五",
    sat: "六",
    sun: "日",
    please_enter_a_user_name: "请输入用户名",
    your_login_has_timed_out_please_click_the_button_to_log_in_again:
      "您的登录已经超时，请点击按钮重新登录",
    please_complete_all_comments_before_submission: "请完成全部评价再提交！",
    please_fill_in: "请输入",
    it_cannot_be_empty: "不能为空",
    comment_successful: "评价成功",
    update_password_successful: "修改密码成功",
    if_there_is_no_prompt_on_the_browser_please_try_again:
      "如果浏览器上没有提示，请重试。",
    click_here_to_try_again: "点此重试",
    if_you_have_not_installed_the_live_streaming_tool:
      "如还未安装直播工具，请下载后再重试。",
    class_information: "上课信息",
    reload: "重新加载",
    you_do_not_have_permission_to_access_the_current_page:
      "您没有访问当前页面的权限",
    return_to_home_page: "主页",
    total_points_project_comment: "总分",
    record_course_over_tip_msg: "本课程已结束，请立即进入互动教室上课",
    page_live_entry_tips:
      "如果无法进入Classin客户端，请访问网页端学习。<br>(网页端不能与老师互动交流)",
    page_live_entry_txt: "网页直播上课",
    select_class: "选择班级",
    start: "开始学习",
    download: "点击下载",
    guidelines: "使用指引",
    class_on_phones: "手机上课",
    class_on_phones_tip: "手机扫描二维码或打开链接地址后可访问移动端",
    copy_successfully: "复制成功"
  }
};



// WEBPACK FOOTER //
// ./src/lang/zh-CN/index.js